import React from 'react';

import './spinner.style.css';

const spinner = () => <div className="Spinner">Loading...</div>;

export default spinner;
